import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Table, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Fancybox from "../../Component/FancyBox";
import Switch from "react-switch";
import { API } from "../../App";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Pagination from "rc-pagination";
import Cookies from "js-cookie";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

const KeyboardCategories = () => {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Store original data for reset
  const navigate = useNavigate();
  const [dataLength, setDataLength] = useState(1);
  const [current, setCurrent] = useState(1);
  const [iconcoror, setIconcoror] = useState("name_up");
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [search, setSearch] = useState({
    name: "",
    status: "",
  });
  const [isDragging, setIsDragging] = useState(false); // Track drag state

  // Fetch keyboard categories
  const loadData = async () => {
    try {
      const token = Cookies.get("jwt");
      const res = await API.post(
        "/keyboardCategories",
        {},
        { headers: { authorization: `Bearer ${token}` } }
      );
      if (res.data.response_code === 0) {
        navigate("/");
      } else {
        setData(res.data.data || []);
        setOriginalData(res.data.data || []); // Store original data
      }
    } catch (error) {
      toast.error("Failed to load categories", { position: "bottom-right" });
      setData([]);
      setOriginalData([]);
    }
  };

  // Sorting function
  const sorting = (col, order, e) => {
    if (isDragging) return; // Prevent sorting while dragging

    setIconcoror(e.target.id);
    const sorted = [...data].sort((a, b) => {
      if (order === "ASC") {
        return a[col] > b[col] ? 1 : -1;
      } else {
        return a[col] < b[col] ? 1 : -1;
      }
    });
    setData(sorted);
  };

  // Pagination functions
  const getPaginatedData = (current, pageSize) => {
    return data.slice((current - 1) * pageSize, current * pageSize);
  };

  const handleStatusChange = async (id, e, name, index) => {
    try {
      const status = e === true ? true : false;
      const updatedData = [...data];
      updatedData[index][name] = status;
      setData(updatedData);

      const token = Cookies.get("jwt");
      await API.post(
        "/keyboardCategories/updateStatus",
        {
          id,
          Status: status,
        },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      toast.success("Status updated successfully", {
        position: "bottom-right",
        autoClose: 500,
      });
    } catch (error) {
      toast.error("Failed to update status", { position: "bottom-right" });
    }
  };

  const deleteCategory = async (id) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger me-3",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = Cookies.get("jwt");
            await API.post(
              `/keyboardCategories/delete/${id}`,
              {},
              {
                headers: { authorization: `Bearer ${token}` },
              }
            );
            loadData();
            toast.success("Category deleted successfully", {
              position: "bottom-right",
              autoClose: 500,
            });
          } catch (error) {
            toast.error("Failed to delete category", {
              position: "bottom-right",
            });
          }
        }
      });
  };

  const handleSearch = async (e) => {
    try {
      const { name, value } = e.target;
      const updatedSearch = { ...search, [name]: value };
      setSearch(updatedSearch);

      const token = Cookies.get("jwt");
      const res = await API.post(
        "/keyboardCategories/search",
        {
          name: updatedSearch.name,
          status: updatedSearch.status,
        },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      setData(res.data.data || []);
      setDataLength(res.data.data?.length > 0 ? 1 : 0);
    } catch (error) {
      toast.error("Search failed", { position: "bottom-right" });
      setData([]);
    }
  };

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = async (e) => {
    setIsDragging(false);

    if (!e.destination) return;

    try {
      let tempData = Array.from(data);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      setData(tempData);

      const arr = tempData.map((val, index) => ({
        id: val._id,
        rank: index + 1,
      }));

      const token = Cookies.get("jwt");
      const result = await API.post("/keyboardCategories/updateIndex", arr, {
        headers: { authorization: `Bearer ${token}` },
      });

      if (result.data.response_code === 1) {
        toast.success(result.data.response_message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
          closeOnClick: true,
        });
        loadData(); // Reload to get updated order from server
      } else {
        toast.error(result.data.response_message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
          closeOnClick: true,
        });
      }
    } catch (error) {
      toast.error("Failed to update order", { position: "bottom-right" });
    }
  };

  const PerPageChange = (value) => {
    setSize(value);
    const newPerPage = Math.ceil(data.length / value);
    if (current > newPerPage) {
      setCurrent(newPerPage);
    }
  };

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return <button className="paggination-btn">Previous</button>;
    }
    if (type === "next") {
      return <button className="paggination-btn">Next</button>;
    }
    return originalElement;
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Keyboard Categories</h3>
        <Row className="align-items-center">
          <Col md="auto" xs={12}>
            <Form.Control
              type="text"
              name="name"
              placeholder="Search Name"
              className="my-1"
              onChange={handleSearch}
            />
          </Col>
          <Col md="auto" xs={12}>
            <Form.Select className="my-1" name="status" onChange={handleSearch}>
              <option value="">Select Status</option>
              <option value={true}>ON</option>
              <option value={false}>OFF</option>
            </Form.Select>
          </Col>
          <Col md="auto" xs={6}>
            <Form.Select
              className="my-1"
              onChange={(e) => {
                setSize(Number(e.target.value));
                setCurrent(1);
              }}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md="auto" xs={12}>
            <Link to="/keyboard/category/add">
              <Button variant="primary" className="my-1 me-2">
                Add New
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="page-content">
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <DragDropContext
                  onDragStart={handleDragStart}
                  onDragEnd={handleDragEnd}
                >
                  <Table bordered responsive>
                    <thead>
                      <tr>
                        <th width="5%" className="text-center">
                          No
                        </th>
                        <th width="50%">
                          <div className="table-sort-filter">
                            Name
                            {data.length > 1 ? (
                              <span className="table-sort">
                                <i
                                  className={`sort-down ${
                                    iconcoror === "name_up" ? "active" : ""
                                  }`}
                                  id="name_up"
                                  onClick={(e) => sorting("name", "ASC", e)}
                                  title="Sort A-Z"
                                ></i>
                                <i
                                  className={`sort-up ${
                                    iconcoror === "name_down" ? "active" : ""
                                  }`}
                                  id="name_down"
                                  onClick={(e) => sorting("name", "DSC", e)}
                                  title="Sort Z-A"
                                ></i>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </th>
                        {/* <th width="15%" className="text-center">
                          Image
                        </th> */}
                        <th width="15%" className="text-center">
                          <div className="table-sort-filter justify-content-center">
                            Status
                            {data.length > 1 ? (
                              <span className="table-sort">
                                <i
                                  className={`sort-down ${
                                    iconcoror === "status_up" ? "active" : ""
                                  }`}
                                  id="status_up"
                                  onClick={(e) => sorting("status", "ASC", e)}
                                  title="Sort ON-OFF"
                                ></i>
                                <i
                                  className={`sort-up ${
                                    iconcoror === "status_down" ? "active" : ""
                                  }`}
                                  id="status_down"
                                  onClick={(e) => sorting("status", "DSC", e)}
                                  title="Sort OFF-ON"
                                ></i>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </th>
                        <th width="15%" className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <Droppable droppableId="droppable-1">
                      {(provider) => (
                        <tbody
                          ref={provider.innerRef}
                          {...provider.droppableProps}
                        >
                          {getPaginatedData(current, size).map((val, id) => (
                            <Draggable
                              key={val._id}
                              draggableId={val._id}
                              index={id}
                            >
                              {(provider) => (
                                <tr
                                  key={id}
                                  {...provider.draggableProps}
                                  ref={provider.innerRef}
                                  {...provider.dragHandleProps}
                                  className={isDragging ? "dragging-row" : ""}
                                >
                                  <td className="text-center">{id + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      {val.name}
                                    </div>
                                  </td>
                                  {/* <td className="text-center">
                                    {val.image && (
                                      <Fancybox>
                                        <a
                                          data-fancybox="gallery"
                                          href={val.image}
                                        >
                                          <img
                                            src={val.image}
                                            className="hv-40 bg-light"
                                            alt="category"
                                          />
                                        </a>
                                      </Fancybox>
                                    )}
                                  </td> */}
                                  <td className="text-center">
                                    <Switch
                                      onChange={(e) =>
                                        handleStatusChange(
                                          val._id,
                                          e,
                                          "status",
                                          id
                                        )
                                      }
                                      checked={val.status === true}
                                      offColor="#C8C8C8"
                                      onColor="#0093ed"
                                      height={30}
                                      width={70}
                                      className="react-switch"
                                      uncheckedIcon={
                                        <div className="react-switch-off">
                                          OFF
                                        </div>
                                      }
                                      checkedIcon={
                                        <div className="react-switch-on">
                                          ON
                                        </div>
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Link
                                      to={`/keyboard/category/view/${val._id}`}
                                    >
                                      <Button
                                        variant="outline-warning"
                                        size="sm"
                                        className="me-2 btn-icon"
                                      >
                                        <i className="bx bx-show"></i>
                                      </Button>
                                    </Link>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="btn-icon"
                                      onClick={() => deleteCategory(val._id)}
                                    >
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                          {provider.placeholder}
                        </tbody>
                      )}
                    </Droppable>
                  </Table>
                </DragDropContext>

                {data.length > size && (
                  <div className="pagination-custom">
                    <Pagination
                      className="pagination-data"
                      onChange={PaginationChange}
                      total={data.length}
                      current={current}
                      pageSize={size}
                      showSizeChanger={false}
                      itemRender={PrevNextArrow}
                      onShowSizeChange={PerPageChange}
                      showTitle={false}
                    />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default KeyboardCategories;
